import styled from 'styled-components';

export const SettingsWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.div`
  background: ${({ theme }) => theme.iconButtonBackgroundColor};
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;

  svg path {
    fill: ${({ theme }) => theme.iconButtonFill};
  }
`;
